import Category from "./category";

const MacroExam = {
  Category,
};

export default MacroExam;
